import React from "react";
import { FinalOutputView } from "./FinalOutput.view";

export const FinalOutput: React.FC = () => {
  return (
    <FinalOutputView />
  );
};
